import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../components/buttons';
import { getMasterData, saveCustomField, getCustomFieldDetails } from './actions/CustomFieldActions';
import { Field, reduxForm } from 'redux-form';
import { isValidNameWithSpace, renderAutoCompleteSingleSelect, renderTextField } from '../../../../components/reduxFields';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import React from 'react';
import validate from './validate';
// import { checkFieldExistence } from '../../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../modules/AppConfig/actions';
import { displayCustomError } from '../../../../../src/actions/utilAction';
import SmallLoader from '../../../../img/small-loader.gif';

class CustomFieldModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = ({
      open: true,
      customFieldId: props.customFieldId || null,
    });
    this.onDateChange = this.onDateChange.bind(this);
  }

  componentWillMount() {
    this.props.getMasterData();
    if (this.state.customFieldId) {
      this.props.getCustomFieldDetails(this.state.customFieldId);
    }
  };
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }
  handleOpen = () => {
    this.setState({ open: true });

  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.clearFieldErrorArray();
      this.props.closeDialog();
    }
  };
  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.customFieldId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleSave=(formProps) => {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formProps.id = this.state.customFieldId;
    formProps.customLabelName = formProps.customLabelName.trim();
    // here this id is not using currently, will be used in future dynamically.
    formProps.customLabelTypeId = 43;
    this.props.clearFieldErrorArray();
    this.props.saveCustomField(formProps);
    this.setState({ open: false });
    this.props.closeDialog();
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Saving" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.handleSave.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose}/>,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={(this.state.customFieldId) ? 'Edit Custom Field' : 'Add Custom Field'}
          modal={false}
          actions={actions}
          open={this.state.open}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSave)}>
                <div className="row">
                  <div className="col-sm-6 require">
                    <Field
                      autoFocus={true}
                      name="customLabelName"
                      label="Field Name"
                      maxLength="50"
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Label name')}
                      customError={displayCustomError('CUSTOMLABELNAME', this.props.fieldError)}
                      normalize = {isValidNameWithSpace}
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-6 require mt-35">
                    <Field
                      name="roleTypeId"
                      label="Link To"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.userRoleTypes}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>);
  }
}
CustomFieldModal = reduxForm({
  form: 'CustomFieldModalForm',
  validate,
  enableReinitialize: true,

})(CustomFieldModal);
function mapStateToProps(state, ownProps) {
  let userRoleTypes = [], initialValueData = null;
  if (state.custom_field.master_data) {
    userRoleTypes = state.custom_field.master_data.userRoleType || [];
  }
  if (ownProps.customFieldId && state.custom_field.customFieldDetails) {
    initialValueData = state.custom_field.customFieldDetails.data;
  }
  return {
    loading: state.custom_field.loading,
    userRoleTypes: userRoleTypes,
    initialValues: initialValueData,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
  };
}
export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveCustomField, getMasterData, getCustomFieldDetails })(CustomFieldModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/customFields/custom_field_modal.js